import BaseComponent from '@/components/base';
import { getStyle } from '@/components/promo-card/style.js';
import { defineComponent } from '@/components/base';
import PromoNotice from '@/components/promo-notice/index';
import PromoEvents from '@/components/promo-notice/events';

export default class PromoCard extends BaseComponent {
  onConnect() {
    const promoContainer = this.shadowRoot.querySelector('.promo-container');
    if (promoContainer) {
      promoContainer.addEventListener('click', () => {
        this.applyDiscountCode();
      });
    }
  }

  async applyDiscountCode() {
    if (!this.discountCode) {
      console.warn('No discount code available');
      return;
    }

    try {
      // Apply discount coupon to cart
      console.log('Applying discount code:', this.discountCode);
      const response = await fetch(
        window.Shopify.routes.root + 'cart/update.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            discount: this.discountCode
          })
        }
      );

      const data = await response.json();

      if (response.ok && response.status === 200) {
        // Show success feedback
        this.showSuccessFeedback();

        // Update cart UI if necessary
        this.updateCartUI();

        // Define promo-notice component if not already defined
        defineComponent('promo-notice', PromoNotice);

        // Find or create promo-notice in the DOM
        let promoNotice = document.querySelector('promo-notice');

        if (!promoNotice) {
          // Create promo-notice element if it doesn't exist
          promoNotice = document.createElement('promo-notice');
          document.body.appendChild(promoNotice);

          promoNotice.addEventListener(PromoEvents.ContinueShopping, () => {
            window.location.href = '/pages/shop-all';
          });

          promoNotice.addEventListener(PromoEvents.ViewCart, () => {
            window.location.href = '/cart';
          });
        }

        // Show the modal
        promoNotice.show();
      } else {
        console.error('Error applying discount. Status:', response.status);
        throw new Error(`Error applying discount: ${response.status}`);
      }
    } catch (error) {
      console.error('Error applying discount code:', error);
      this.showErrorFeedback();
    }
  }

  showSuccessFeedback() {
    const promoContainer = this.shadowRoot.querySelector('.promo-container');
    if (promoContainer) {
      promoContainer.style.transform = 'scale(0.95)';
      promoContainer.style.transition = 'transform 0.2s ease';

      setTimeout(() => {
        promoContainer.style.transform = 'scale(1)';
      }, 200);

      // Add temporary class to indicate success
      promoContainer.classList.add('applied');
      setTimeout(() => {
        promoContainer.classList.remove('applied');
      }, 1000);
    }
  }

  showErrorFeedback() {
    const promoContainer = this.shadowRoot.querySelector('.promo-container');
    if (promoContainer) {
      promoContainer.style.border = '2px solid #ff4444';
      promoContainer.style.transition = 'border 0.3s ease';

      setTimeout(() => {
        promoContainer.style.border = '';
      }, 2000);
    }
  }

  updateCartUI() {
    // Dispatch custom event to update cart UI
    window.dispatchEvent(new CustomEvent('cart:updated'));
  }

  get title() {
    return this.getAttribute('title') || '';
  }

  get image() {
    return this.getAttribute('image') || '';
  }

  get link() {
    return this.getAttribute('link') || '';
  }

  get discountCode() {
    return this.getAttribute('discount-code') || '';
  }

  get style() {
    return getStyle({
      isMobile: this.isSmall
    });
  }

  render() {
    return `
      ${this.style}
      <div class="promo-container">
        <img 
          src="${this.image}" 
          alt="${this.title}"
          class="promo-image"
        />
        <div class="promo-title">
          ${this.title}
        </div>
      </div>
    `;
  }
}
